import { styled } from '@mui/material/styles';

/**
 * Shared bordered, scrollable container for long blocks of pre-formatted copy
 * (terms text, consent text). Kept in one place because TermsField and
 * ConsentField previously carried byte-identical copies.
 */
export const ScrollableBoxWrapper = styled('div')(
    ({ theme }) => `
    border-width: 1px;
    border-radius: 10px;
    border-color: ${theme.palette.grey[500]};
    border-style: solid;
    margin: 10px 0 10px 0;
    overflow: hidden;
`,
);

export const ScrollableBoxContent = styled('div')(
    ({ theme }) => `
    background-color: #fff;
    overflow-y: auto;
    max-height: 200px;
    color: ${theme.palette.grey[900]};
    box-shadow: none;
    line-height: 24px;
    padding: 8px 12px 8px 12px;
    font-size: 14px;
    p {
        margin: 0 !important;
    }
`,
);
